


































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Icon, Picker, Popup, List } from 'vant';
import SearchBar from '@/components/next/SearchBar.vue';
import { getList } from '../api';

Vue.use(Icon)
  .use(Picker)
  .use(Popup)
  .use(List);

@Component({
  components: {
    SearchBar,
  },
})
export default class Home extends Vue {
  showPicker = false;

  list: any[] = [];
  nowtime: number = new Date().getTime();
  loading = false;
  finished = false;
  page = 1;
  keyword = '';

  mounted() {}
  onClear() {
    this.resetList();
  }

  async onGetList() {
    this.loading = true;
    const ret = await getList(this.page, this.keyword);
    // console.log('ret::', ret);
    this.loading = false;
    this.list = [...this.list, ...ret.data];
    if (ret.data.length) {
      this.page++;
    } else {
      this.finished = true;
    }
  }
  resetList() {
    this.page = 1;
    this.finished = false;
    this.loading = false;
    this.list = [];
  }
  onNavTo(postItem: any, index: number) {
    this.$router.push(`detail?id=${postItem.id}`);
  }
  onSearch() {
    this.resetList();
    this.onGetList();
  }
}
